const getCareerIdFromCSV = async (careerName) => {
  try {
    const response = await fetch('/output.csv');
    const csvText = await response.text();
    const lines = csvText.split('\n');
    
    const searchName = careerName.toLowerCase().trim();
    let bestMatch = null;
    let bestScore = 0;
    
    for (let i = 1; i < lines.length; i++) {
      const [id, name] = lines[i].split(',');
      if (name) {
        const csvName = name.toLowerCase().trim();
        
        if (csvName === searchName) {
          return id;
        }
        
        const words = searchName.split(/[\s-]+/);
        let score = 0;
        
        words.forEach(word => {
          if (csvName.includes(word)) score++;
        });
        
        if (score > bestScore) {
          bestScore = score;
          bestMatch = { id, name: csvName, score };
        }
      }
    }
    
    if (bestMatch && bestScore > 0) {
      return bestMatch.id;
    }
    
    return null;
  } catch (error) {
    console.error('Error fetching career ID:', error);
    return null;
  }
};

export default getCareerIdFromCSV;